module.exports = __webpack_public_path__ + "img/album18_56.328bff88.jpg";